// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yFD3","field":"styles_field__25FXt","fieldCol":"styles_fieldCol__1W8f5","diffCol":"styles_diffCol__3czx-","diff":"styles_diff__3qqQ1"};